import React from 'react'
import { Grid } from 'semantic-ui-react'

import { GridContainer } from '../StyledComponents'

const toArray = (item) => (Array.isArray(item) ? item : [item])

const FormLayout = ({
  visible,
  labelPosition = 'left',
  children,
  label,
  labelFieldProportions,
  fieldProportions,
  labelStyles,
  autoHeight,
  className,
}) => {
  const actualChildren = toArray(children)

  const containerWidth = Math.floor(16 / actualChildren.length)
  const labelFieldProportion = labelFieldProportions ? labelFieldProportions.split(':') : []
  const fieldProportion = fieldProportions ? fieldProportions.split(':') : []

  const labelMarkup = (
    <Grid.Column
      width={parseInt(labelFieldProportion[0], 10) || 4}
      verticalAlign="middle"
      textAlign={labelPosition === 'right' ? 'left' : 'right'}
      style={{ wordWrap: 'break-word', paddingLeft: 0 }}
    >
      <span style={labelStyles}>{label}</span>
    </Grid.Column>
  )

  return visible ? (
    <GridContainer className={className} style={!autoHeight ? { minHeight: 40 } : undefined} smallPadding>
      <Grid>
        <Grid.Row verticalAlign="middle">
          {label && labelPosition === 'left' && labelMarkup}

          <Grid.Column style={{ paddingLeft: 0, paddingRight: 0 }} width={labelFieldProportion[1] || 12}>
            <GridContainer smallPadding>
              <Grid>
                <Grid.Row verticalAlign="middle">
                  {actualChildren.map((child, index) => (
                    <Grid.Column
                      key={index}
                      style={{
                        paddingLeft: 0,
                        paddingRight: index === actualChildren.length - 1 ? 0 : 5,
                      }}
                      width={fieldProportion[index] || containerWidth}
                    >
                      {child}
                    </Grid.Column>
                  ))}
                </Grid.Row>
              </Grid>
            </GridContainer>
          </Grid.Column>

          {labelPosition === 'right' && labelMarkup}
        </Grid.Row>
      </Grid>
    </GridContainer>
  ) : (
    !autoHeight && <div style={{ height: 40 }} />
  )
}

FormLayout.defaultProps = {
  visible: true,
}

export default FormLayout
